import { WidgetStatePublisher as BasePublisher } from '../../shared/WidgetStatePublisher';
import type { HeatmapWidgetStateParams } from '../types';

export class HeatmapWidgetStatePublisher extends BasePublisher<HeatmapWidgetStateParams> {}
